import { Compass, ShieldAlert, Hammer, CheckCircle2 } from "lucide-react";
import { WHY_US, IMAGES } from "@/lib/constants";
import { useInView } from "@/hooks/useInView";

const ICONS = [Compass, ShieldAlert, Hammer, CheckCircle2];

const Card = ({ item, idx }) => {
  const { ref, inView } = useInView();
  const Icon = ICONS[idx];
  return (
    <div
      ref={ref}
      data-testid={`why-card-${idx}`}
      className={`relative bg-white border border-[#E5E7EB] p-10 md:p-12 fade-up ${
        inView ? "in-view" : ""
      } transition-all hover:border-[#0A1128]/30 hover:shadow-[0_30px_60px_-30px_rgba(10,17,40,0.25)]`}
      style={{ transitionDelay: `${idx * 100}ms` }}
    >
      <div className="flex items-start gap-6">
        <div className="shrink-0 w-12 h-12 bg-[#0A1128] text-[#00A859] flex items-center justify-center">
          <Icon size={22} strokeWidth={1.6} />
        </div>
        <div className="flex-1">
          <div className="font-heading text-[10px] tracking-[0.3em] text-[#00A859] uppercase mb-3">
            0{idx + 1} / 04
          </div>
          <h3 className="font-heading text-[#0A1128] text-2xl md:text-[26px] font-medium leading-tight mb-4">
            {item.title}
          </h3>
          <p className="font-body text-[#4B5563] text-[15px] md:text-base leading-relaxed">
            {item.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export const WhyUs = () => {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="relative bg-white py-24 md:py-32 overflow-hidden"
    >
      {/* Blueprint corner accent */}
      <div
        className="absolute -right-32 -top-20 w-[640px] h-[640px] opacity-[0.06] pointer-events-none hidden lg:block"
        style={{
          backgroundImage: `url(${IMAGES.blueprint})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          maskImage:
            "radial-gradient(circle at center, black 0%, transparent 70%)",
          WebkitMaskImage:
            "radial-gradient(circle at center, black 0%, transparent 70%)",
        }}
      />

      <div className="relative max-w-[1320px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="max-w-3xl mb-16 md:mb-20">
          <div className="ra-eyebrow mb-6">
            <span className="ra-hairline" />
            <span>Why Ramo Advisors</span>
          </div>
          <h2 className="font-heading text-[#0A1128] text-3xl md:text-4xl lg:text-[52px] font-medium leading-[1.08] tracking-tight">
            A Trusted Advisor for{" "}
            <span className="text-[#00A859]">Complex Projects.</span>
          </h2>
          <p className="font-body text-[#4B5563] text-base md:text-[17px] leading-relaxed mt-6">
            We sit on the same side of the table as ownership — bringing
            objective, risk-first thinking to every decision that shapes a
            project&apos;s outcome.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {WHY_US.map((item, i) => (
            <Card key={item.title} item={item} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
